const initState = {
  active: false,
  title: "",
  type: "",
  size: "",
};

const modalReducer = (state = initState, action) => {
  switch (action.type) {
    case "SHOW_MODAL":
      return {
        ...state,
        active: true,
        title: action.payload.title,
        type: action.payload.type,
        size: action.payload.size,
      };
    case "HIDE_MODAL":
      return { ...state, active: false };
    default:
      return state;
  }
};

export default modalReducer;
